// src/componentes/Layout/index.js
import React, { useState } from 'react';
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import Header from './header';
import Sidebar from './sidebar';
import { Outlet } from 'react-router-dom'; // 👈 Import Outlet

const drawerWidth = 0;
const collapsedWidth = 0;

const Layout = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [mobileOpen, setMobileOpen] = useState(false);
    const [desktopOpen, setDesktopOpen] = useState(true);

    const handleToggleSidebar = () => {
        if (isMobile) {
            setMobileOpen(!mobileOpen);
        } else {
            setDesktopOpen(!desktopOpen);
        }
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <Header onToggleSidebar={handleToggleSidebar} />

            <Sidebar
                isMobile={isMobile}
                mobileOpen={mobileOpen}
                onCloseMobile={() => setMobileOpen(false)}
                desktopOpen={desktopOpen}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    transition: 'margin 0.3s',
                    pt: 10,
                    px: 3,
                    ml: isMobile ? 0 : desktopOpen ? `${drawerWidth}px` : `${collapsedWidth}px`,
                    backgroundColor: '#f4f6f8',
                    minHeight: '100vh',
                }}
            >
                <Outlet /> {/* 👈 Render the child routes here */}
            </Box>
        </Box>
    );
};

export default Layout;